import { UserPhone } from '@centecomm/portal-service';

export enum AccountActions {
    SET_PHONE_NUMBERS = 'SET_PHONE_NUMBERS',
}

interface SetPhoneNumbersAction {
    type: typeof AccountActions.SET_PHONE_NUMBERS;
    payload: UserPhone[];
}

export type AccountActionTypes = SetPhoneNumbersAction;
